// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setBusinessId, setBusinessInfo } from "../../stores/business/businessSlice";
import { WelcomeBanner } from "../../components/WelcomeBanner";
import { CategoriesPreview } from "../../components/CategoriesPreview";
import { Footer } from "../../components/Footer";
import { FALLBACK_BUSINESS, FALLBACK_BUSINESS_ID } from "../../data/fallback";
import { API_URL } from "../../config/api";

const RoomService = () => {
    const PUBLIC_TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW5pcy5taW1pbmlAY2xpY2thbGJhbmlhLmNvbSIsImlhdCI6MTc1MDk4MjU3NywiZXhwIjoxNzUxMjQxNzc3fQ.yQ3xGQEfpj62ruJoLJYOl3966g55OlyofRqjoAHzu";
    const dispatch = useDispatch();

    const businessId = '2';

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Same as the home page: an unreachable API falls back to the bundled business,
        // and servicesSlice falls back to the bundled service list alongside it.
        const applyFallback = () => {
            dispatch(setBusinessId(FALLBACK_BUSINESS_ID));
            dispatch(setBusinessInfo(FALLBACK_BUSINESS));
        };

        const validateBusiness = async () => {
            try {
                const response = await fetch(`${API_URL}/api/v1/business/data/${businessId}`, {
                    headers: {
                        Authorization: `Bearer ${PUBLIC_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    dispatch(setBusinessId(businessId));
                    dispatch(setBusinessInfo(data));
                } else {
                    applyFallback();
                }
            } catch (error) {
                applyFallback();
            } finally {
                setLoading(false);
            }
        };

        validateBusiness();
    }, [businessId, dispatch, PUBLIC_TOKEN]);

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
                <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                <p className="mt-4 text-xs font-bold text-slate-400 uppercase tracking-widest">Loading Concierge</p>
            </div>
        );
    }

    return (
        <div className="flex-1 bg-slate-50">
            <WelcomeBanner />

            <div className="flex-1">
                <CategoriesPreview />
            </div>

            <Footer />
        </div>
    );
};

export default RoomService;
